// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#create-group-form {
  padding: 10px 20px 20px 20px;
}

#language-select {
  width: 300px;
  max-width: 300px
}

.form-element {
  margin-top: 10px;
  min-height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/css/components/create-group.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":["#create-group-form {\n  padding: 10px 20px 20px 20px;\n}\n\n#language-select {\n  width: 300px;\n  max-width: 300px\n}\n\n.form-element {\n  margin-top: 10px;\n  min-height: 36px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
